import React from 'react';
import PropTypes from 'prop-types';
import { Translate } from 'react-redux-i18n';
import Icon from 'front-onceforall-core/dist/components/Icon';
import { TextField } from '@material-ui/core';
import { AbstractFormComponent, validators } from 'front-onceforall-core';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export class CreditsEditorForm extends AbstractFormComponent {
  getFormData() {
    return {
      projectCredits: this.props.credits?.projectCredits,
      requestForApprovalCredits: this.props.credits?.requestForApprovalCredits
    };
  }
  getFormValidators() {
    return {
      projectCredits: [validators.requiredValidator, validators.numberValidator],
      requestForApprovalCredits: [validators.requiredValidator, validators.numberValidator]
    };
  }
  handleSubmitCallback() {
    this.props.onValidate({
      projectCredits: Number(this.state.formData.projectCredits),
      requestForApprovalCredits: Number(this.state.formData.requestForApprovalCredits)
    });
  }
  render() {
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("span", {
        className: "flex-container mb-5",
        children: /*#__PURE__*/_jsx("h1", {
          children: /*#__PURE__*/_jsx(Translate, {
            value: "organisation.page.modifyCredits"
          })
        })
      }), this.props.credits && /*#__PURE__*/_jsxs("form", {
        onSubmit: this.handleSubmit,
        children: [/*#__PURE__*/_jsxs("div", {
          className: "row mb-5",
          children: [/*#__PURE__*/_jsx("div", {
            className: "col-6 d-flex align-items-center",
            children: /*#__PURE__*/_jsx(Translate, {
              value: "organisation.page.projectCreditsModifier"
            })
          }), /*#__PURE__*/_jsx("div", {
            className: "col-6",
            children: /*#__PURE__*/_jsx(TextField, {
              id: "project-credits",
              name: "project-credits",
              type: "number",
              error: this.isOnError('projectCredits'),
              helperText: this.helperText('projectCredits'),
              value: this.state.formData.projectCredits,
              onChange: this.handleChange('projectCredits'),
              InputLabelProps: {
                shrink: true
              },
              InputProps: {
                inputProps: {
                  min: 0
                }
              },
              variant: "outlined"
            })
          })]
        }), /*#__PURE__*/_jsxs("div", {
          className: "row mb-5",
          children: [/*#__PURE__*/_jsx("div", {
            className: "col-6 d-flex align-items-center",
            children: /*#__PURE__*/_jsx(Translate, {
              value: "organisation.page.requestForApprovalCreditsModifier"
            })
          }), /*#__PURE__*/_jsx("div", {
            className: "col-6",
            children: /*#__PURE__*/_jsx(TextField, {
              id: "request-credits",
              name: "request-credits",
              type: "number",
              error: this.isOnError('requestForApprovalCredits'),
              helperText: this.helperText('requestForApprovalCredits'),
              value: this.state.formData.requestForApprovalCredits,
              onChange: this.handleChange('requestForApprovalCredits'),
              InputLabelProps: {
                shrink: true
              },
              InputProps: {
                inputProps: {
                  min: 0
                }
              },
              variant: "outlined"
            })
          })]
        }), /*#__PURE__*/_jsxs("div", {
          className: "actions col-12 inline-container space-between",
          children: [/*#__PURE__*/_jsxs("button", {
            type: "button",
            className: "large secondary inline-container",
            onClick: this.props.onCancel,
            "data-id": "cancel",
            children: [/*#__PURE__*/_jsx(Translate, {
              value: "action.back"
            }), /*#__PURE__*/_jsx(Icon, {
              icon: "go-back"
            })]
          }), /*#__PURE__*/_jsxs("button", {
            className: "large cta inline-container",
            type: "submit",
            disabled: this.state.submitting,
            children: [/*#__PURE__*/_jsx(Translate, {
              value: "action.confirm"
            }), /*#__PURE__*/_jsx(Icon, {
              icon: this.state.submitting ? 'loader' : 'check'
            })]
          })]
        })]
      })]
    });
  }
}
CreditsEditorForm.propTypes = {
  credits: PropTypes.object,
  onCancel: PropTypes.func.isRequired,
  onValidate: PropTypes.func.isRequired
};
export default CreditsEditorForm;